import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SystemApp } from '../constans/SystemConfigurations';
import { ApiUrl } from '../apiurl.models';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  private baseUrl = SystemApp.base_url_api;

  constructor(private http: HttpClient, private apiUrl: ApiUrl) {}


  private getHeaders(authRequired: boolean = true): HttpHeaders {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    if (authRequired) {
      const auth = this.apiUrl.getJWTToken();
      if (auth) {
        headers = headers.set('Authorization', auth);
      }
    }

    return headers;
  }

  // 🔹 Generic GET
  get<T>(endpoint: string, params?: any, authRequired: boolean = true): Observable<T> {
    const options = {
      headers: this.getHeaders(authRequired),
      params: new HttpParams({ fromObject: params || {} })
    };
    return this.http.get<T>(`${this.baseUrl}/${endpoint}`, options);
  }

  // 🔹 Generic POST
  post<T>(endpoint: string, data: any, authRequired: boolean = true): Observable<T> {
    const options = { headers: this.getHeaders(authRequired) };
    return this.http.post<T>(`${this.baseUrl}/${endpoint}`, data, options);
  }

  // 🔹 Generic PUT
  put<T>(endpoint: string, data: any, authRequired: boolean = true): Observable<T> {
    const options = { headers: this.getHeaders(authRequired) };
    return this.http.put<T>(`${this.baseUrl}/${endpoint}`, data, options);
  }

  // 🔹 Generic PATCH — partial update, for editing a single field without
  // round-tripping (and potentially clearing) the rest of the record.
  patch<T>(endpoint: string, data: any, authRequired: boolean = true): Observable<T> {
    const options = { headers: this.getHeaders(authRequired) };
    return this.http.patch<T>(`${this.baseUrl}/${endpoint}`, data, options);
  }

  // 🔹 Generic DELETE
  delete<T>(endpoint: string, authRequired: boolean = true): Observable<T> {
    const options = { headers: this.getHeaders(authRequired) };
    return this.http.delete<T>(`${this.baseUrl}/${endpoint}`, options);
  }
}
